import { render } from "./noticeList.vue?vue&type=template&id=2dc25f1a&scoped=true"
import script from "./noticeList.vue?vue&type=script&lang=js"
export * from "./noticeList.vue?vue&type=script&lang=js"

import "./noticeList.vue?vue&type=style&index=0&id=2dc25f1a&scoped=true&lang=css"
import "@/styles/striNew.css?vue&type=style&index=1&lang=css"
import "./noticeList.vue?vue&type=style&index=2&id=2dc25f1a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-partnerpage-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc25f1a"]])

export default __exports__